import classNames from "classnames";
import InputWrapper from "../../../../components/Input/InputWrapper";

const Checkbox = ({id, formik, settings = {}}) => {
    return (
            <InputWrapper className="checkbox">
                <label className="option">
                    <input
                        type="checkbox"
                        checked={String(formik.values[id]) === "true"}
                        onClick={() => formik.setFieldValue(id, String(formik.values[id]) === "false" ? "true" : "false")}
                    />
                    <span className="checkmark"></span>
                </label>

                <div>
                    <label className={classNames({"required": settings.required})}>
                        {settings.title}
                    </label>

                    {settings.description && <p className="description">{settings.description} </p>}
                </div>
            </InputWrapper>
    )
};

export default Checkbox;